import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import Checkbox from "@infotech/uikit-checkbox"
import FieldSet from "@infotech/uikit-fieldset"
import { Field } from "redux-form"
import cn from "classnames"
import Input from "@infotech/uikit-input"
import { Box } from "@infotech/uikit-grid"
import { fieldWrapper } from "src/engine/modules/reduxForm"
import styles from "./styles.css"

const InputRF = fieldWrapper(Input)
const MAX_LENGTH = 25

const LinkInput = props => {
  const {
    meta: { error },
    input: { value },
  } = props
  return (
    <Box loose>
      <InputRF {...props} />
      {!error && (
        <Box loose flex row className={styles.LinkNameHint}>
          <p>Максимальное кол-во символов {MAX_LENGTH}</p>
          {value && (
            <p
              className={cn(
                styles.Rest,
                MAX_LENGTH < value.length && styles.NegativeRest,
              )}
            >
              Осталось {MAX_LENGTH - value.length}
            </p>
          )}
        </Box>
      )}
    </Box>
  )
}

LinkInput.propTypes = {
  props: PropTypes.shape({
    meta: PropTypes.shape({
      error: PropTypes.string,
    }),
    input: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
}

LinkInput.defaultProps = {
  props: {
    meta: {
      error: null,
    },
    input: { value: null },
  },
}

const LinkContent = ({
  haveLink,
  isDisabled,
  changeFormValue,
  getTestAttribute,
}) => {
  const [isLinkFieldsVisible, toggleLinkFieldsVisibility] = useState(haveLink)
  useEffect(() => {
    if (haveLink) {
      toggleLinkFieldsVisibility(true)
    }
  }, [haveLink])
  useEffect(() => {
    if (!isLinkFieldsVisible) {
      changeFormValue(`externalLinkTemplate`, null)
    }
    if (isLinkFieldsVisible && !haveLink) {
      changeFormValue(`externalLinkTemplate.name`, null)
      changeFormValue(`externalLinkTemplate.template`, null)
    }
  }, [isLinkFieldsVisible])
  return (
    <Box loose flex column pt="2md">
      <Box className={styles.Rectangle} loose />
      <Box loose pt="2md">
        <Checkbox
          label="Добавить ссылку на внешнюю систему"
          disabled={isDisabled}
          checked={isLinkFieldsVisible}
          onCheckedChange={toggleLinkFieldsVisibility}
        />
      </Box>
      {isLinkFieldsVisible && (
        <Box loose flex column>
          <Box loose pt="2md">
            <div
              data-testid={getTestAttribute(`externalLinkTemplate-template`)}
            >
              <FieldSet caption="Шаблон ссылки на внешнюю систему" required>
                <Field
                  name="externalLinkTemplate.template"
                  placeholder="Укажите ссылку на внешнюю систему"
                  component={InputRF}
                  getProps={meta => ({
                    error: meta.error,
                  })}
                  props={{
                    disabled: isDisabled,
                  }}
                />
              </FieldSet>
            </div>
          </Box>
          <Box loose pt="2md">
            <div data-testid={getTestAttribute(`externalLinkTemplate-name`)}>
              <FieldSet caption="Наименование ссылки" required>
                <Field
                  name="externalLinkTemplate.name"
                  placeholder="Введите наименование ссылки"
                  component={LinkInput}
                  getProps={meta => ({
                    error: meta.error,
                  })}
                  props={{
                    disabled: isDisabled,
                  }}
                />
              </FieldSet>
            </div>
          </Box>
        </Box>
      )}
    </Box>
  )
}

LinkContent.propTypes = {
  haveLink: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  changeFormValue: PropTypes.func.isRequired,
}

export default LinkContent
